module.exports = __webpack_public_path__ + "img/vipjf88.12d0f050.png";